/* eslint-disable react/jsx-curly-brace-presence */
import styled from '@emotion/styled';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import Button from '@base/Button/Button';
import Link from '@base/Link/Link';
import Head from 'next/head';
import Image from '@base/Image';
import { Spacings } from '@styles/index';

const Empty = styled.div`
  grid-column: 9/17;
  text-align: center;
  padding-top: ${Spacings.SPACING_10B};
  align-items: center;
  display: flex;
  height: calc(
    100vh -
      ${Spacings.SPACING_HEADER +
      Spacings.SPACING_FOOTER +
      Spacings.SPACING_HEADER_MARGIN +
      Spacings.SPACING_FOOTER_MARGIN}px
  );
  min-height: 448px;
  flex-direction: column;
`;

const NoCourses = styled(H3)`
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_3B};
  color: var(--color-text-primary);
`;

const Back = styled(Button)`
  margin-top: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_13B};
`;

const Error = ({
  title = 'Oops! Page not found...',
  description = "Looks like you're looking for something that doesn't exist."
}) => {
  const onBack = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      window.open(window.location.origin, '_self');
    }
  };

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Empty>
        <Image src={'error.svg'} alt="error" width={400} height={260} />
        <NoCourses>{title}</NoCourses>
        {description ? (
          <P1 color="var(--color-text-secondary)">{description}</P1>
        ) : null}
        <Link href="/">
          <Back onClick={onBack} label="Go home" grid={2} />
        </Link>
      </Empty>
    </>
  );
};

export default Error;
